import { createSelector } from 'reselect';

export const selectSwingSubmittalTypes = createSelector(
  state => state.subscription.swingSubmittals.types,
  types => (types ? types.toJS() : null)
);

export const selectSwingSubmittals = createSelector(
  state => state.subscription.swingSubmittals.submittals,
  submittals => (submittals ? submittals.toJS() : null)
);



// WEBPACK FOOTER //
// ./src/subscription/coaching/swing-submittals/redux/selectors.js